import { render, staticRenderFns } from "./VuetifyDatepicker.vue?vue&type=template&id=a920cd3c"
import script from "./VuetifyDatepicker.vue?vue&type=script&lang=js"
export * from "./VuetifyDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports